import { Component } from '@theme/component';

// Rendimiento oficial: 10-12 m² por litro A UNA CAPA (usuario, 07-09-2026).
// A las dos manos recomendadas ≈ 6 m²/L, que es lo que calcula este widget —
// y la cifra impresa en las imágenes de la galería (kit 2L → 12 m²,
// kit 4L → 24 m²): la calculadora no puede decir otra.
const COVERAGE_M2_PER_LITER_TWO_COATS = 6;

/**
 * PPZ Paint Calculator
 *
 * Calcula litros aproximados a partir de los m² introducidos y recomienda
 * el kit (2L o 4L, los únicos tamaños reales del Kit para pintar paredes).
 * Todo en el navegador — no hace ninguna llamada de red.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} input
 * @property {HTMLElement} result
 *
 * @extends {Component<Refs>}
 */
export class PpzPaintCalculator extends Component {
  requiredRefs = ['input', 'result'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.input.addEventListener('input', this.#handleInput);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.input.removeEventListener('input', this.#handleInput);
  }

  #handleInput = () => {
    const area = Number(this.refs.input.value);

    if (!area || area <= 0) {
      this.refs.result.hidden = true;
      this.refs.result.textContent = '';
      return;
    }

    const liters = Math.ceil((area / COVERAGE_M2_PER_LITER_TWO_COATS) * 10) / 10;

    this.refs.result.innerHTML = `Necesitarás aprox. <strong>${this.#formatLiters(
      liters
    )}</strong> · te recomendamos ${this.#recommendKit(liters)}`;
    this.refs.result.hidden = false;
  };

  /** @param {number} liters */
  #recommendKit(liters) {
    if (liters <= 2) return 'el kit de <strong>2L</strong>';
    if (liters <= 4) return 'el kit de <strong>4L</strong>';

    const kits = Math.ceil(liters / 4);
    return `<strong>${kits} kits de 4L</strong>`;
  }

  /** @param {number} liters */
  #formatLiters(liters) {
    return `${liters.toLocaleString('es-ES')} L`;
  }
}

if (!customElements.get('ppz-paint-calculator')) {
  customElements.define('ppz-paint-calculator', PpzPaintCalculator);
}
